/**
 * @fileoverview Styles for the Form component in the Storyteller application.
 * Contains styles for the form container and button layouts with responsive design.
 *
 * @example
 * // Usage in component:
 * import styles from './Form.module.css'
 *
 * <div className={styles.container}>
 *   <form>
 *
 *   </form>
 *   <div className={styles.button_container}>
 *     <button>Cancel</button>
 *     <button>Submit</button>
 *   </div>
 * </div>
 */


.container {
    position: relative;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 1rem;
}

.button_container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.5rem;
    margin: 0.5rem 0 0;
    flex-direction: column-reverse;
    margin-top: auto;
}

.button_container button {
    width: 100%;
}

@media (min-width: 768px) {
    .button_container {
        flex-direction: row;
    }

    .button_container button {
        width: auto;
        margin-top: 1rem;
    }
}
